import React, { Component } from 'react';
import PlanOutput from '../../containers/PlanOutput/PlanOutput';
import Methodology from '../../components/Methodology/Methodology';
import Disclaimer from '../../components/Disclaimer/Disclaimer';
import PageHeader from '../../components/PageHeader/PageHeader';
import { connect } from 'react-redux';
import * as actionCreators from '../../store/actionCreators';
import classes from './SimpleReportBuilder.css';
import ScrollToTopOnMount from '../ScrollToTopOnMount/ScrollToTopOnMount';
import CoverPage from '../../components/CoverPage/CoverPage';
import InformationPage from '../../components/InformationPage/InformationPage';
import Glossary from '../../components/Glossary/Glossary';
import AdditionalCalculatorInfo from '../../components/AdditionalCalculatorInfo/AdditionalCalculatorInfo';

export class SimpleReportBuilder extends Component {

    componentDidMount() {
        setTimeout(() => {
            let node = document.getElementById('planReport');
            let output = node.innerHTML;
            this.props.generatePDF(output);
        }, 250);

    }

    render() {
        return (
            <div>
                <ScrollToTopOnMount />
                <div className="buttonContainer">
                    <a href={this.props.downloadUrl} download target={"_blank"}>Download</a>
                </div>
                <div id="planReport" className={classes.SimpleReportBuilder}>
                    <div className="page">
                        <CoverPage />
                    </div>
                    <div className="page">
                        <InformationPage
                            advisorInfo={this.props.advisorInfo}
                            planInfo={this.props.planInfo}
                            portfolioInfo={this.props.standardPortfolioInfo}
                            interest={this.props.interest}
                            equity={this.props.equity}
                            IP7Allocations={this.props.IP7Allocations}
                            indexAchieverAllocations={this.props.indexAchieverAllocations}
                            indexProtector={this.props.indexProtector}
                            productReducer={this.props.productReducer}
                        />
                    </div>
                    <div className="page">
                        <PageHeader title="Plan Comparison" />
                        <PlanOutput displayMode={true} />
                    </div>
                    <div className="page">
                        <PageHeader title="Calculator Notes" />
                        <Methodology
                            indexProtector={this.props.indexProtector}
                            productReducer={this.props.productReducer}
                        />
                    </div>
                    <div className="page">
                        <PageHeader title="Disclaimer" />
                        <Disclaimer isPrint={true} indexProtector={this.props.indexProtector} />
                    </div>
                    <div className="page">
                        <PageHeader title="Glossary" />
                        <Glossary indexProtector={this.props.indexProtector} />
                    </div>
                    <div className="page">
                        <PageHeader title="Additional Calculator Information" />
                        <AdditionalCalculatorInfo
                            indexProtector={this.props.indexProtector}
                        />
                    </div>
                </div>

            </div>
        );
    }
}

const mapStatetoProps = (state) => {
    return {
        downloadUrl: state.planOutputState.downloadUrl,
        advisorInfo: state.registrationState.registration,
        planInfo: state.planInfo,
        standardPortfolioInfo: state.planOutputState.standardPlan.portfolioInfo,
        equity: state.planOutputState.conditions.equity,
        interest: state.planOutputState.conditions.interest,
        IP7Allocations: state.planInfo.IP7.indexAllocation,
        indexAchieverAllocations: state.planInfo.IndexAchiever.indexAllocation,
        indexProtector: state.globalState.indexProtector,
        productReducer: state.productReducer
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        generatePDF: (data) => dispatch(actionCreators.generateDownloadUrl(data))
    }
};

export default connect(mapStatetoProps, mapDispatchToProps)(SimpleReportBuilder);


// WEBPACK FOOTER //
// ./src/containers/SimpleReportBuilder/SimpleReportBuilder.js